<template>
  <div class="footer">
    <div class="footer-item">
      <md-button
        class="md-primary md-border-primary md-button-large has-icon copied"
        :class="{ 'copied': linkWasClicked }"
        @click="handleCopy"
      >
        <base-icon class="icon" :icon-name="linkWasClicked ? 'check' : 'copy-2'" />
        {{ linkWasClicked ? 'Link Copied' : 'Copy Link' }}
      </md-button>
    </div>
    <div class="footer-item">
      <md-button
        class="md-primary md-raised md-button-large"
        @click="handleShare"
      >
        Share
      </md-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ShareModalFooter',
    data() {
      return {
        linkWasClicked: false,
      };
    },
    methods: {
      handleShare () {
        this.$emit('on-share')
      },
      handleCopy() {
        this.linkWasClicked = true;
        this.$emit('on-copy');
        setTimeout(() => {
          this.linkWasClicked = false;
        }, 4000);
      }
    },
  };
</script>

<style lang="scss" scoped>
  .footer {
    @include flexRow;
    justify-content: flex-end;
    width: 100%;
    .md-button.md-button-large {
      height: 48px !important;
    }
  }
  .footer-item + .footer-item {
    margin-left: 24px;
  }
  .copied {
    width: 174px;
  }
</style>
